// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1BwN9","label":"SetPasswdForm_label__2eldx"};